import React, { useContext } from 'react'
import './DotsLoader.css'
import lottie from "lottie-web";
import LoaderIcon from '../../../images/loader.json'
import { SpeakerContext } from '../../../context/SpeakerContext';
import { loaderGif } from '../../../images/images';
import { LoaderRipple } from 'unified-ui-components-library';


const DotsLoader = ({msg}) => {
  const { handleAudioIconDisplay } = useContext(SpeakerContext)
  const bdy = document.querySelector('body')
  React.useEffect(() => {

    handleAudioIconDisplay(false)
    bdy.style.overflow = 'hidden'
    const instance = lottie.loadAnimation({
      container: document.querySelector("#loaderWrapper"),
      animationData: LoaderIcon,
    });
    return () => {
      instance.destroy()
      handleAudioIconDisplay(true)
      bdy.style.overflow = 'auto'
    };
  }, []);
  return (
    <div className="loaderWrapper">
      <div className="loadWrapperInner">
        {/* <div className='' id="loaderWrapper"></div> */}
        {/* <img className='loaderGif' src={loaderGif} alt='loader_gif'/> */}
        <LoaderRipple type = "secondary"/>
        <p>{msg}</p>
      </div>

    </div>
  )
}

export default DotsLoader